// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3FGYs","inner":"Footer_inner__3Rmom","nextIcon":"Footer_nextIcon__3Q3lu","innerLeft":"Footer_innerLeft__1Lpi-"};